export const VIEW_REQUEST_IS_NOT_DISCLOSE_APPROVED = {
    label: '開示する',
    value: 1,
};
export const VIEW_REQUEST_IS_DISCLOSE_APPROVED = {
    label: '開示済',
    value: 2,
};
export const VIEW_REQUEST_IS_DISCLOSE_APPROVALS = [VIEW_REQUEST_IS_NOT_DISCLOSE_APPROVED, VIEW_REQUEST_IS_DISCLOSE_APPROVED];
